var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer has-cards"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center justify-content-md-between"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"copyright"},[_vm._v("\n                    ®2024 CESAVESIN\n                ")])]),_c('div',{staticClass:"col-md-6"})])])])
}]

export { render, staticRenderFns }